//import FuseLoadable
import { FuseLoadable } from "@fuse";
//export ImplementationConfig
export const WorkflowConfig = {
  //settings
  settings: {
    //set layout
    layout: {
      //set config as empty object
      config: {}
    }
  },
  //set routes
  routes: [
    {
      path     : '/app/bankRec/workflow',
      component: FuseLoadable({
          loader: () => import('./Mainworkflow')
      })
  }
  ]
  //end routes
};
